import widgetPhone from "../widget-phone/widget-phone.js";

function kharakteristiki(){

    var classesArray = document.getElementsByClassName("product__kharakteristiki");
    if(classesArray.length > 0){
        //document.querySelector(".h-colors").addEventListener('change', function (e) {
        //    vcolor();
        //});

        document.querySelector(".h-types-kor").addEventListener('change', function (e) {
            vtypeskor();
            vnalichnik();
        });

        document.querySelector(".h-nalichnik").addEventListener('change', function (e) {
            vnalichnik();
        });

        document.querySelector(".h-types-pol").addEventListener('change', function (e) {
            vopis();
        });

        var elements = document.querySelectorAll("select"), i;
        for (i = 0; i < elements.length; ++i) {
            elements[i].addEventListener('change', function (e) {
                vprice();
                vlist();
            });
        }

        //vcolor();
        vtypeskor();
        vnalichnik();
        vprice();
        vlist();
    }

}

//function vcolor(){
//    const selectElement = document.querySelector('.h-colors');
//    const color = selectElement.options[selectElement.selectedIndex].dataset.color;
//    document.querySelector(".d-colors").setAttribute("style", "background-color: " + color + ";");
//}
function vtypeskor(){
    const selectElement = document.querySelector('.h-types-kor');
    const id = Number(selectElement.options[selectElement.selectedIndex].dataset.id);
    var stl = '';
    if (id === 3) {
        stl = 'flex';
    } else {
        stl = 'none';
        const select = document.querySelector('.h-nalichnik');
        select.options[0].selected = true;
    }
    var elements = document.querySelectorAll(".s-dop"), i;
    for (i = 0; i < elements.length; ++i) {
        elements[i].setAttribute("style", "display: " + stl + ";");
    }
}

function vnalichnik(){
    const selectElement = document.querySelector('.h-nalichnik');
    const id = Number(selectElement.options[selectElement.selectedIndex].dataset.id);
    var stl = '';
    if (id === 2) {
        stl = 'flex';
    } else {
        stl = 'none';
        const select = document.querySelector('.h-dobor');
        select.options[0].selected = true;
    }
    var elements = document.querySelectorAll(".s-dop2"), i;
    for (i = 0; i < elements.length; ++i) {
        elements[i].setAttribute("style", "display: " + stl + ";");
    }
}

function vprice(){
    var baseprice = Number(document.querySelector('.product__price').dataset.baseprice);
    //var selectElement = document.querySelector('.h-colors');
    //var color = Number(selectElement.options[selectElement.selectedIndex].dataset.plusprice);
    var selectElement = document.querySelector('.h-sizes');
    var sizes = Number(selectElement.options[selectElement.selectedIndex].dataset.plusprice);
    selectElement = document.querySelector('.h-types-pol');
    var typespol = Number(selectElement.options[selectElement.selectedIndex].dataset.plusprice);
    selectElement = document.querySelector('.h-types-kor');
    var typeskor = Number(selectElement.options[selectElement.selectedIndex].dataset.plusprice);
    var id = Number(selectElement.options[selectElement.selectedIndex].dataset.id);
    //var price = baseprice+color+sizes+typespol+typeskor;
    var price = baseprice+sizes+typespol+typeskor;
    if (id === 3) {
        selectElement = document.querySelector('.h-nalichnik');
        var nalichnik = Number(selectElement.options[selectElement.selectedIndex].dataset.plusprice);
        var id2 = Number(selectElement.options[selectElement.selectedIndex].dataset.id);
        price = price+nalichnik;
        if (id2 === 2) {
            selectElement = document.querySelector('.h-dobor');
            var dobor = Number(selectElement.options[selectElement.selectedIndex].dataset.plusprice);
            price = price+dobor;
        }
    }
    selectElement = document.querySelector('.h-ostekleniye');
    var osteklenieid = Number(selectElement.dataset.id);
    //console.log(osteklenieid);
    if (osteklenieid === 1) {
        var osteklenie = Number(selectElement.dataset.plusprice);
            price = price+osteklenie;
    }
    document.querySelector('.button-to-cart').setAttribute('data-price', price);
    document.querySelector('.product__price').innerHTML = price.toLocaleString() + ' ₽';
}

function vlist(){
    var selectElement = document.querySelector('.h-colors');
    //var color = selectElement.options[selectElement.selectedIndex].text;
    selectElement = document.querySelector('.h-sizes');
    var sizes = selectElement.options[selectElement.selectedIndex].text;
    selectElement = document.querySelector('.h-types-pol');
    var typespol = selectElement.options[selectElement.selectedIndex].text;
    selectElement = document.querySelector('.h-types-kor');
    var typeskor = selectElement.options[selectElement.selectedIndex].text;
    var id = Number(selectElement.options[selectElement.selectedIndex].dataset.id);
    //var list = 'Цвет: ' + color + ',\r\n Размер по полотну: ' + sizes + ',\r\n Тип полотна: ' + typespol + ',\r\n Тип коробки: ' + typeskor + '';
    var list = 'Размер по полотну: ' + sizes + ',\r\n Тип полотна: ' + typespol + ',\r\n Тип коробки: ' + typeskor + '';
    if (id === 3) {
        selectElement = document.querySelector('.h-nalichnik');
        var nalichnik = selectElement.options[selectElement.selectedIndex].text;
        var id2 = Number(selectElement.options[selectElement.selectedIndex].dataset.id);
        list = list + ',\r\n ' + nalichnik + '';
        if (id2 === 2) {
            selectElement = document.querySelector('.h-dobor');
            var dobor = selectElement.options[selectElement.selectedIndex].text;
            list = list + ',\r\n ' + dobor + '';
        }
    }
    selectElement = document.querySelector('.h-ostekleniye');
    var osteklenieid = Number(selectElement.dataset.id);
    if (osteklenieid === 1) {
        var osteklenie = selectElement.value;
        list = list + ',\r\n ' + osteklenie + '';
    }
    list = list + '\r\n ';
    document.querySelector('.button-to-cart').setAttribute('data-list', list);
}

function vopis(){
    var selectElement = document.querySelector('.h-types-pol');
    var id = Number(selectElement.options[selectElement.selectedIndex].dataset.id);
    if (id === 1) {
        document.querySelector(".p-sta").classList.add("hidden");
        document.querySelector(".p-eco").classList.remove("hidden");
    } else if (id === 2) {
        document.querySelector(".p-eco").classList.add("hidden");
        document.querySelector(".p-sta").classList.remove("hidden");
    }
}

export default kharakteristiki;